import { Spin } from 'antd';
import { BtlBaseForm } from '../BtlBaseForm';
import { propertyFormSchema } from './formSchema';
import { useFinancingAndPropertyForm } from './useFinancingAndPropertyForm';

export function Property() {
  const form = useFinancingAndPropertyForm({
    formName: 'property',
    getFormSchema: propertyFormSchema,
  });

  if (form.isLoading) {
    return <Spin size='large' />;
  }

  return <BtlBaseForm {...form.formProps} />;
}

export default Property;
